/*
 * TODO: Remove inline styling. Need to fix scss module import issue
 */
import { mergeClassnames } from '@porterin/component-library/src/utils/mergeClassnames';
import React from 'react';

type library = 'NATIVE' | 'MUI';

type buttonInteractions = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

type buttonOptions = {
  disabled?: boolean;
};

type identifiers = {
  id: string;
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  identifiers: identifiers;
  children: React.ReactNode;
  library?: library;
  interactions?: buttonInteractions;
  buttonOptions?: buttonOptions;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      identifiers,
      children,
      library = 'NATIVE',
      interactions,
      buttonOptions,
      className = '',
      ...props
    },
    ref,
  ) => {
    return (
      <button
        id={identifiers.id}
        ref={ref}
        disabled={buttonOptions?.disabled}
        className={mergeClassnames(
          `
					px-4 py-5 
					inline-flex items-center justify-center rounded-md 
          font-semibold text-black text-2xl 
          `,
          `${buttonOptions?.disabled ? 'opacity-60 cursor-not-allowed' : ''}`,
          className,
        )}
        onClick={interactions?.onClick}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
